import React from "react";
import img1 from "../../assets/img/Children.png"
import img2 from "../../assets/img/Hands.png"
import img3 from "../../assets/img/cek.png"


const MainNews = () => {
  return (<>
    <section className="kids-section m-0  p-0">
      <div className="h-96 bg-cover relative bg-center  ">
        <div className="flex w-full h-full pl-10  flex-col items-start  justify-around   " >
          <h1 className="text-white xl:w-full w-3/5 lg:text-[28px] sm:text-[20px] text-5xl">
            Doğmalarla birgə keçirilən gün yaddaşlarınıza xüsusi həkk olunur
          </h1>
          <p className="text-white  text-xl  lg:text-[16px]  sm:text-[12px]  xl:w-full w-1/2  ">
            Eleifend gravida mattis erat sagittis. Curabitur lacus dolor
            porttitor eu quisque lectus. Amet et amet turpis sit. Sed magna
            feugiat netus ut bibendum malesuada dignissim lectus. Massa quis non
            quis justo.
          </p>
          <button className="text-red font-bold lg:mt-0 mt-7  bg-white rounded-xl px-10 py-1">Ətraflı</button>
        </div> 
      </div>


      <div className="h-96 bg-cover relative bg-center ">
        <div className="flex w-full h-full  px-10  flex-col items-end  justify-around   " >
          <h1 className="text-white xl:w-full w-3/5 lg:text-[28px] sm:text-[20px] text-5xl">
          Uşaqların şərəfinə “ŞanlıUrfa”-da möhtəşəm şou-proqram baş tutacaq!
          </h1>
          <p className="text-white  lg:text-[16px] sm:text-[12px]  text-xl xl:w-full w-1/2 ">
          Augue sed cras sed cursus morbi. Venenatis neque, elementum dolor posuere. Duis viverra praesent sit rhoncus. Sed sit adipiscing vitae semper amet. Sem gravida in nec hendrerit sed vel.
          </p>
          <button className="text-red font-bold lg:mt-0 mt-7  bg-white rounded-xl px-10 py-1">Ətraflı</button>
        </div> 
      </div>


      <div className="h-96 bg-cover relative bg-center  ">
        <div className="flex w-full h-full  pl-10  flex-col items-start  justify-around   " >
          <h1 className="text-white xl:w-full w-3/5 lg:text-[28px] sm:text-[20px] text-5xl">
            Doğmalarla birgə keçirilən gün yaddaşlarınıza xüsusi həkk olunur
          </h1>
          <p className="text-white  lg:text-[16px] sm:text-[12px]  text-xl xl:w-full w-1/2   ">
            Eleifend gravida mattis erat sagittis. Curabitur lacus dolor
            porttitor eu quisque lectus. Amet et amet turpis sit. Sed magna
            feugiat netus ut bibendum malesuada dignissim lectus. Massa quis non
            quis justo.
          </p>
          <button className="text-red font-bold lg:mt-0 mt-7  bg-white rounded-xl px-10 py-1">Ətraflı</button>
        </div> 
      </div>
    </section>
    </>
  );
};

export default MainNews;
